import { render, staticRenderFns } from "./PrayerPage.vue?vue&type=template&id=0382aac5&"
import script from "./PrayerPage.vue?vue&type=script&lang=js&"
export * from "./PrayerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports